import { useCallback, useEffect, useRef } from 'react';

/**
 * 열려 있는 동안 한 번만 실행을 허용하는 래치. 다시 열리면 초기화된다.
 * 모달이 닫히는 애니메이션 동안 이전 트리가 DOM 에 남아 클릭을 더 받으므로,
 * 그 트리에서도 최신값이 보이도록 state 가 아니라 ref 로 판정한다.
 */
export const useOnceWhileOpen = (isOpen: boolean) => {
  const claimedRef = useRef(false);

  useEffect(() => {
    if (isOpen) claimedRef.current = false;
  }, [isOpen]);

  return useCallback(() => {
    if (claimedRef.current) return false;
    claimedRef.current = true;
    return true;
  }, []);
};
